import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Responses/Requests
import { Result } from "@/main/models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { saveBodyshopType } from "./index";

// Api's
import { bodyshopTypeApi } from "@/main/api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getBodyshopTypeSaga() {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(bodyshopTypeApi.getDomain);

		if (response.data.result) {
			yield put(saveBodyshopType(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveBodyshopType(null, true, resultError.messagesDataError));
		}
	}
}
